/**************
 Menu Scroll
 ***************/

const header = document.querySelector('#header').parentElement;
const headerHeight = header.offsetHeight;
const announcement = document.querySelector('#announcement');

// on scroll, when moving down,hide menu. On scroll up, roll menu back
let scrollPosition = window.scrollY;

function hideOnScroll() {
    window.scrollY > scrollPosition
        ?
        // make sure the announement bar is scrolled off
        announcement.getBoundingClientRect().bottom <= 0
            ? header.style.transform = 'translateY(-110%)'
            : ""
        : header.style.transform = 'translateY(0)';
    // reset current comparison
    scrollPosition = window.scrollY;
}

window.addEventListener('scroll', hideOnScroll);

/**************
 Mobile Nav
 ***************/

// nested menus
document.querySelectorAll('.sliderContentNavGroupTrigger').forEach(el => {
    el.addEventListener('click', function () {
        this.classList.add('active');
    })
})

// return button
document.querySelectorAll('.sliderContentNavGroupReturn').forEach(el => {
    el.addEventListener('click', function () {
        document.querySelectorAll('.sliderContentNavGroupTrigger').forEach(el => el.classList.remove('active'));
    })
})


// open nav
function openNav() {
    // open modal and remove scroll on body
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
    // set height of the content as it relates to the header
    document.querySelector("#sliderContent").style.height =
        `${window.innerHeight - header.getBoundingClientRect().bottom}px`;
    document.querySelector("#sliderContent").style.top = `${header.getBoundingClientRect().bottom}px`;
    // active on slider content
    document.querySelector('#sliderContent').classList.add('active');
    // active on buttons
    header.querySelector('#headerMobileButtons').classList.add('active');
}

// dialog close event
document.querySelector("#slider").addEventListener("click", async function (e) {
    if (e.target === this) {
        await closeNav();
    }
});

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector('#sliderContent').classList.remove('active');
    header.querySelector('#headerMobileButtons').classList.remove('active');
    setTimeout(() => {
        document.querySelector("#slider").close();
    }, 450)
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));

/**************
 Homepage Transparent Nav
 ***************/

// On the homepage the bar sits over the hero with no background. Colours,
// scrim and the layout lift live in assets/theme-header-transparent.css;
// this only sets `isSolid`, for the two states CSS cannot see - the page
// being scrolled, and the mobile menu / search drawer being open. Hover
// and focus are handled in the stylesheet.
(function () {

    const bar = document.getElementById('header');
    if (!bar || !bar.classList.contains('headerHomepage')) return;

    // theme-header-transparent.css only loads when the "Transparent nav over
    // homepage hero" theme setting is on, and it is the only thing that sets
    // this marker - so if it is missing, the feature is off and so is this.
    if (getComputedStyle(bar).getPropertyValue('--mc-transparent-nav').trim() !== '1') return;

    const wrap = bar.parentElement;

    // how far down the page the bar turns white
    const SOLID_AT = 100;

    let scrolled = false;
    let panelOpen = false;

    function apply() {
        bar.classList.toggle('isSolid', scrolled || panelOpen);
    }

    // an identity transform, or none at all - see measure()
    function isSettled(t) {
        return t === 'none' || t === 'matrix(1, 0, 0, 1, 0, 0)';
    }

    // --mc-header-h: getBoundingClientRect, not offsetHeight. The bar is
    // 59.33px tall and offsetHeight rounds it to 59 or 60 depending on where
    // the announcement bar above happens to land, which would leave a 1px seam.
    // The stylesheet hard-codes the same numbers so the first paint is already
    // right; this re-states them from the DOM so the layout survives a change
    // to either. A height does not move with scroll, so it is always safe.
    //
    // --mc-header-top is the distance from the top of the document down to the
    // bar - in practice the height of the announcement bar above it - and the
    // stylesheet subtracts it from the hero's height. Reading it off `wrap` is
    // only valid in one specific state, because two things move that element
    // without moving it in layout:
    //
    //   position: sticky - once stuck, getBoundingClientRect().top reports the
    //   sticky offset rather than the document offset, so `rect.top + scrollY`
    //   collapses to roughly scrollY. Any re-measure part-way down the page
    //   (a resize, a reload that restored a scroll position, the ResizeObserver
    //   below) therefore wrote the scroll offset into --mc-header-top, which
    //   resized the hero, which resized the document - so the page grew as you
    //   scrolled up and you could never reach the top.
    //
    //   hideOnScroll at the top of this file animates `transform` on this same
    //   wrapper over 300ms to roll the bar out of and back into view, which
    //   skews rect.top for the duration.
    //
    // So: only read it at scroll 0, and only once the transform has settled.
    // The stylesheet fallbacks (42px desktop / 30px mobile) cover a page that
    // loads part-way down, and onScroll re-measures on arrival at the top.
    function measure() {
        const root = document.documentElement;
        root.style.setProperty('--mc-header-h', bar.getBoundingClientRect().height + 'px');
        if (window.scrollY > 0) return;
        if (!isSettled(getComputedStyle(wrap).transform)) return;
        root.style.setProperty('--mc-header-top', Math.max(0, wrap.getBoundingClientRect().top) + 'px');
    }

    // -- scroll --

    let ticking = false;

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
            ticking = false;
            // back at the top, so --mc-header-top can be trusted again. This is
            // what re-syncs it after a resize that happened mid-page, or a load
            // that started part-way down.
            if (window.scrollY <= 0) measure();
            const past = window.scrollY > SOLID_AT;
            if (past === scrolled) return;
            scrolled = past;
            apply();
        });
    }

    window.addEventListener('scroll', onScroll, {passive: true});

    // the roll-back transition can still be running when the scroll settles at
    // the top, so take one more reading after it can no longer be in flight
    wrap.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') measure();
    });

    // -- mobile menu + search drawer --

    // #headerMobileButtons gets .active while the mobile nav dialog is open and
    // #headerSearch gets .active while the search drawer is open. Watching the
    // class rather than the triggers keeps this decoupled from openNav/closeNav
    // above and from snippets/header-search.liquid.
    const panels = [
        document.getElementById('headerMobileButtons'),
        document.getElementById('headerSearch')
    ].filter(Boolean);

    function readPanels() {
        panelOpen = panels.some(function (el) {
            return el.classList.contains('active');
        });
        apply();
    }

    if (panels.length && 'MutationObserver' in window) {
        const panelObserver = new MutationObserver(readPanels);
        panels.forEach(function (el) {
            panelObserver.observe(el, {attributes: true, attributeFilter: ['class']});
        });
    }

    // -- go --

    measure();
    scrolled = window.scrollY > SOLID_AT;
    readPanels();

    let resizeTimer;

    function measureSoon() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(measure, 150);
    }

    window.addEventListener('resize', measureSoon);
    window.addEventListener('load', measure);

    // catches the bar changing height on its own - the webfont swapping in,
    // the cart badge appearing - which neither of the above would see
    if ('ResizeObserver' in window) new ResizeObserver(measureSoon).observe(bar);

})();
